import './ContactForm.css'

const ContactForm = () => {
  return (
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSdXFE9DNsATm9jm6Krtfl4tAToA6cIRyQOGfdkfAQEeZyc4mg/viewform?embedded=true"
      width="100%"
      height="100%"
      frameBorder="0"
      className="contact-form"
    >
      Cargando…
    </iframe>
  )
}

export default ContactForm
